<template>
    <div>
        <!-- Header row (no link) -->
        <div v-if="!item.link" :class="[
            item.container_class,
            item.class,
            'py-2',
            depth > 0 ? 'pl-3 border-l border-[var(--border-gray)]' : ''
        ]">
            <span v-html="item.title || '&nbsp;'"></span>
            <MiniBadge v-if="item.badge" :label="item.badge" class="ml-2" />
        </div>

        <!-- Link row -->
        <a v-else :href="item.link" :target="isExternal(item.link) ? '_blank' : undefined"
            :rel="isExternal(item.link) ? 'noreferrer noopener' : undefined" :class="[
                item.container_class,
                item.class,
                'block py-2 px-2 rounded btn-secondary flex items-center justify-between',
                depth > 0 ? 'pl-3 border-l border-[var(--border-gray)]' : ''
            ]">
            <span class="min-w-0 truncate">{{ item.title }}</span>
            <MiniBadge v-if="item.badge" :label="item.badge" class="ml-2 flex-shrink-0" />
            <Icon name="material-symbols-light:chevron-right-rounded" :class="['text-2xl', item.title ? 'ml-2' : '']" />

        </a>

        <!-- Nested items (always expanded) -->
        <ul v-if="item.items?.length" class="mt-1 flex flex-col gap-1" :class="item.items_class">
            <li v-for="(sub, sidx) in item.items" :key="`${sub.title || 'sub'}-${sidx}`">
                <HoverMenuMobileItem :item="sub" :depth="depth + 1" />
            </li>
        </ul>
    </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import type { TMenuItem } from '~/components/HoverMenu2.vue';

export default {
    name: 'HoverMenuMobileItem',
    props: {
        item: {
            type: Object as PropType<TMenuItem>,
            required: true,
        },
        depth: {
            type: Number,
            default: 0,
        },
    },
    methods: {
        isExternal(link: string) {
            return /^https?:\/\//i.test(link);
        },
    },
};
</script>